<template>
    <div ref="container" class="d-flex flex-column container h-100">
        <loading ref="loading"></loading>

        <header class="pt-3 pb-3 text-center">
            <h1 class="h2" style="">{{ $t('translations.self_help')}}</h1>
        </header>

        <div class="card-default-mtb-0">
            <form class="nhs-choices-search text-center">
                <div class="form-group mb-0 position-relative">
                    <label for='search' class="sr-only">{{ $t('translations.search')}}</label>
                    <input maxlength="50" name='search' type='text' class="form-control search-field" :placeholder="this.$t('translations.placeholder_enter_problem_self_help')" v-model='$root.selfHelpSearch'>
                    <button v-if="$root.embed" class="btn btn-search" v-on:click.prevent='getSearchResults'><img src="/img/egl/search-standard3.svg" alt="search" style="width: 20px; height: 20px;"></button>
                    <button v-else class="btn btn-search" v-on:click.prevent='getSearchResults'><img src="/img/icon-search.svg" alt="search" style="width: 20px; height: 20px;"></button>
                </div>
            </form>
        </div>

        <div class="card-default-mtb-0 flex-grow-1-scroll h-100">

            <template v-if='searchResults.length > 0'>
                <template v-for='(result, index) in searchResults'>
                    <a :key='index' :href='result.url' target='nhs_choices' class="help-item">
                        <h4>{{result.name}}</h4>
                        <p>{{result.snippet}}</p>
                    </a>
                </template>
            </template>
            <p class="text-center" v-else>{{ $t('translations.no_search_results_found')}}.</p>
            <!-- <a :href='"https://www.bing.com/search?q=" + encodeURI(search)' target='nhs_choices' class="text-center">Show me more</a> -->
        </div>
        <footer class="container ml-auto mr-auto">
            <!-- <template v-if='!isServiceAvailable()'>
                <p class="m-2 alert alert-warning" >
                    <template v-if='$root.provider.network_service_status == 0'>
                        {{autobrand('translations.network_is_currently_unavailable_for_online_requests')}}
                    </template>
                    <template v-else>
                        {{ serviceAvailabliltyMessage() }}
                    </template>
                </p>
            </template> -->
            <template>
                <!-- <router-link :to='$root.isLoggedIn() ? {name: "threadCreate"} : {name: "loginType"}' tag="button" class="btn btn-round btn-block btn-primary">Consult your own GP</router-link> -->
                <button v-on:click='goBack()' class="btn btn-round btn-block btn-primary mb-2">{{ $t('translations.back')}}</button>
            </template>
        </footer>

    </div><!--ref:container-->


</template>

<script>
export default {
    props: [
    ],
    data: function(){
        return {
            searchResults: [],
        }
    },
    mounted() {
        this.getSearchResults();
    },
    methods: {
        getSearchResults() {
            if(this.$root.selfHelpSearch) {
                var practice_code = this.$root.practice_code;
                if(practice_code == null) {
                    try {
                        if(typeof localStorage === 'object') {
                            practice_code = localStorage.getItem('practice_code');
                        }
                    }
                    catch(e) {

                    }
                }
                this.setLoading(true);
                //axios.post('/api/vp1/patients/authenticate', this.auth).then((res) => {
                axios.get('/api/vp1/search?c=' + practice_code + '&search=' + encodeURI(this.$root.selfHelpSearch)).then((res) => {
                    this.setLoading(false);
                    if(res.data.webPages) {
                        this.searchResults = res.data.webPages.value;
                    }
                    else {
                        this.searchResults = [];
                    }

                }).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "create");
                });
            }
        },
        goBack() {
            var path = this.$route.params.user_id ? "/proxy-select-action/" + this.$route.params.user_id : "/select-action";
            this.$router.push(path);
        }
    }
}
</script>
